import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ZagIcon } from '../icon/icon';

/**
 * Reusable error state component with icon, message, and optional back link.
 *
 * @example
 * ```html
 * <zag-error-state
 *   [message]="error()!"
 *   [backLink]="'/teams'"
 *   [backText]="'common.back' | translate"
 * />
 * ```
 */
@Component({
  selector: 'zag-error-state',
  imports: [RouterLink, ZagIcon],
  template: `
    <div class="error-state">
      <span zagIcon="error-outline" class="error-state__icon"></span>
      <p class="error-state__message">{{ message() }}</p>
      @if (backLink()) {
        <a [routerLink]="backLink()!" class="error-state__back">
          {{ backText() }}
        </a>
      }
    </div>
  `,
  styleUrl: './error-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorStateComponent {
  /**
   * Error message to display.
   */
  readonly message = input.required<string>();

  /**
   * Optional navigation link to go back.
   * @default null
   */
  readonly backLink = input<string | null>(null);

  /**
   * Text for the back link.
   * @default 'Go back'
   */
  readonly backText = input<string>('Go back');
}
